import React from "react"
import { useTranslation } from "react-i18next"

function PPAINotEnabledPage() {
    const [t] = useTranslation()
    return (
        <div className="card shadow">
            <div className="card-body">
                <div className="container">
                    <div className="row">
                        <div className="col">
                            <div className="row">
                                <div className="col text-center">
                                    <h1 className="mb-2 text-bold">{t("PPAIDisabledPage.title")}</h1>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col text-center">
                                    <h3 className="mb-4">{t("PPAIDisabledPage.explaination")}</h3>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col card">
                                    <div className="card-body">
                                        <i className="fas fa-comments fa-5x my-2 text-blue" />
                                        <h3>{t("PPAIDisabledPage.chat")}</h3>
                                        <p className="lead">{t("PPAIDisabledPage.chat_info")}</p>
                                    </div>
                                </div>
                                <div className="col card mx-4">
                                    <div className="card-body">
                                        <i className="fas fa-database fa-5x my-2 text-green" />
                                        <h3>{t("PPAIDisabledPage.prices")}</h3>
                                        <p className="lead">{t("PPAIDisabledPage.prices_info")}</p>
                                    </div>
                                </div>
                                <div className="col card">
                                    <div className="card-body">
                                        <i className="fas fa-chart-line fa-5x my-2 text-red" />
                                        <h3>{t("PPAIDisabledPage.diagrams")}</h3>
                                        <p className="lead">{t("PPAIDisabledPage.diagrams_info")}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="row card my-4">
                                <div className="col card-body">
                                    <h4>{t("PPAIDisabledPage.contact_text")}</h4>
                                    <a
                                        className="btn btn-primary btn-lg mt-4"
                                        href="mailto:info@sylphen.com?subject=PP%20AI%20Chat"
                                    >
                                        {t("PPAIDisabledPage.contact")}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PPAINotEnabledPage
